
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration",
      function () {
        return require("private-next-pages/registration/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration"])
      });
    }
  